/* import __COLOCATED_TEMPLATE__ from './radio-question.hbs'; */
import { action } from '@ember/object';
import Component from '@glimmer/component';

export default class RequestPrescreenerQuestionTypesRadioQuestion extends Component {
  get currentValue() {
    return this.args.validationModel?.value;
  }

  @action
  isOptionChecked(option) {
    return this.currentValue === option;
  }

  @action
  onSelect(question, value) {
    this.args.onChange?.(question, value);
  }
}
